import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import { HomeNav } from '../Common/Home/HomeNav';
import SecurityFiltersProvider from '../Seguranca/Common/Filters/contexts/SecurityFiltersContext';
import Prisioners from './Prisioners/Prisioners';
import RecoveredVehicles from './RecoveredVehicles/RecoveredVehicles';
import Weapons from './Weapons/Weapons';
import NarcoticQuantities from './NarcoticQuantities/NarcoticQuantities';
import Narcotics from './Narcotics/Narcotics';
import ArrestsMade from './ArrestsMade/ArrestsMade';
import Art173Eca from './Art173Eca/Art173Eca';

const dashboardPath = 'dashboardproductivity';

const routes = [
    { menuPath: 'prisioners', Component: Prisioners },
    { menuPath: 'recovered-vehicles', Component: RecoveredVehicles },
    { menuPath: 'weapons', Component: Weapons },
    { menuPath: 'narcotic-quantities', Component: NarcoticQuantities },
    { menuPath: 'narcotics', Component: Narcotics },
    { menuPath: 'arrests-made', Component: ArrestsMade },
    { menuPath: 'art173eca', Component: Art173Eca }
];

function DashBoardProductivity() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <SecurityFiltersProvider>
                <ReactQueryDevtools initialIsOpen={false} />
                <div className="dashboards-page">
                    <HomeNav menus={menus} />
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="prisioners" replace />}
                        />
                        {routes.map(({ menuPath, Component }) => (
                            <Route
                                key={menuPath}
                                path={`/${menuPath}/*`}
                                element={
                                    <Component
                                        dashboardPath={dashboardPath}
                                        menuPath={menuPath}
                                    />
                                }
                            />
                        ))}
                    </Routes>
                </div>
            </SecurityFiltersProvider>
        </QueryClientProvider>
    );
}

export default DashBoardProductivity;
